import { Component, OnInit } from '@angular/core';
import { initFlowbite } from 'flowbite';
@Component({
  selector: 'app-root',
  standalone: false,
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent implements OnInit {
  canUserAccess: boolean = false;
  title = 'Dimot | Market Access';

  ngOnInit (): void {
    initFlowbite();
  }

  giveAccess (value: boolean) {
    //this.canUserAccess = true;
  }
}